/* The Katha: Bundle builder (kh-builder section). Oct 2026.
   One bundle price for 7 pieces (duvet cover, fitted sheet, flat sheet, 2 pillowcase pairs) in any colours,
   plus add-ons at the bundle discount. The bundle product's variant carries the colours as line properties.
   Colours: product names, with the team's "Studio colour" entries (Admin > Content) for swatch colour,
   status (In stock / Back soon / Hidden) and an optional photo. */
(function () {
  document.querySelectorAll('[data-kbb]').forEach(init);

  function init(root) {
    var CAT = JSON.parse(root.querySelector('[data-kbb-cat]').textContent);
    var TX = JSON.parse(root.querySelector('[data-kbb-tx]').textContent);
    var $ = function (sel) { return root.querySelector(sel); };
    var KEYS = ['duvet', 'fitted', 'flat', 'pillow1', 'pillow2'];
    var SRC = { duvet: 'duvet', fitted: 'fitted', flat: 'flat', pillow1: 'pillow', pillow2: 'pillow' };
    var PILLOWS = ['pillow1', 'pillow2'];

    /* ---------- data ---------- */
    var HEX = {};
    (CAT.hex || '').split('\n').forEach(function (l) { var i = l.indexOf(':'); if (i > 0) HEX[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim(); });
    var MO = {};
    (CAT.mo || []).forEach(function (m) { if (m && m.f && m.c) MO[String(m.f).toLowerCase() + '|' + String(m.c).toLowerCase().trim()] = m; });
    var SIZES = (CAT.sizes || '').split('\n').map(function (l) { var p = l.split('|').map(function (x) { return x.trim(); }); return p[0] ? { n: p[0], cm: p[1] || '', b: p[2] || p[0] } : null; }).filter(Boolean);
    /* single-piece prices for colours only sold as a 3-pc set: "Fabric | piece | size price | ..." (Rp) */
    var SINGLE = {};
    (CAT.singlePrices || '').split('\n').forEach(function (l) {
      var p = l.split('|').map(function (x) { return x.trim(); }); if (p.length < 3) return;
      var m = SINGLE[p[0].toLowerCase() + '|' + p[1].toLowerCase()] = {};
      p.slice(2).forEach(function (x) { var r = x.match(/^(.*\S)\s+([\d.,]+)$/); if (r) m[r[1].toLowerCase()] = parseInt(r[2].replace(/[.,]/g, ''), 10) * 100; });
    });
    var KINGP = (CAT.kingPillow || '').toLowerCase().split(',').map(function (x) { return x.trim(); });
    /* bed sizes where the buyer picks standard or king pillowcases; every other size gets its default */
    var PCHOICE = (CAT.pillowChoice || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    function pillowChoice(size) { return PCHOICE.indexOf(String(size).toLowerCase()) > -1; }

    function money(c) { return 'Rp ' + Math.round(c / 100).toLocaleString('id-ID'); }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
    function mo(name, fabKey) { return MO[String(fabKey || (state && state.fabric) || '').toLowerCase() + '|' + String(name || '').toLowerCase()]; }
    /* swatch paint: Studio colour entry, then the colour list (may be a stripe pattern) */
    function paintOf(name) { var k = String(name || '').toLowerCase(); if (/gradient/.test(HEX[k] || '')) return HEX[k]; var m = mo(name); if (m && m.h) return m.h; return HEX[k] || '#E6E1DB'; }
    /* a flat colour for tinting the photo (first colour of a stripe pattern) */
    function tintOf(name) { var p = paintOf(name), m = p.match(/#[0-9a-f]{6}/i); return m ? m[0] : p; }
    function hidden(name, fabKey) { var m = mo(name, fabKey); return !!(m && m.s === 'Hidden'); }
    function soon(name) {
      var m = mo(name); if (!m) return '';
      if (m.s === 'Sold out') return TX.soldOutShort;
      if (m.s !== 'Back soon') return '';
      return m.d ? TX.backSoon.replace('[date]', m.d) : TX.backSoon.replace('[date]', 'soon');
    }
    /* Pre-order: can be picked even with no stock; the note goes on the swatch, the piece and the order */
    function preorder(name) {
      var m = mo(name); if (!m || m.s !== 'Pre-order') return '';
      return m.n || (m.d ? TX.preDate.replace('[date]', m.d) : TX.preNote);   // own note, else its date, else the default
    }

    function piecesOf(f) { return f.pieces || {}; }
    /* one colour order for every piece (the duvet covers' order), so a colour sits in the same spot each row */
    function orderOf(f) { if (!f._order) { var o = []; ['duvet', 'flat', 'fitted', 'pillow'].forEach(function (k) { Object.keys(piecesOf(f)[k] || {}).forEach(function (c) { if (o.indexOf(c) < 0) o.push(c); }); }); f._order = o; } return f._order; }
    function coloursOf(f, key) { var ord = orderOf(f); return Object.keys(piecesOf(f)[SRC[key]] || {}).filter(function (c) { return !hidden(c, f.key); }).sort(function (a, b) { return ord.indexOf(a) - ord.indexOf(b); }); }
    /* a fabric can be built when every piece has a colour that isn't hidden */
    function buildable(f) { return KEYS.every(function (k) { return coloursOf(f, k).length; }); }
    var state = null;
    var ALL = CAT.fabrics.filter(function (f) { return Object.keys(piecesOf(f)).length; });
    var FABS = ALL.filter(buildable);
    if (!FABS.length) return;

    function fab() { return FABS.filter(function (f) { return f.key === state.fabric; })[0] || FABS[0]; }
    function sizeObj() { return SIZES.filter(function (x) { return x.n === state.size; })[0] || SIZES[0]; }
    function coloursFor(key) { return coloursOf(fab(), key); }

    /* A piece's variant for the bed size. Duvet covers come as "full & queen" / "king & cali king";
       King AU uses the king duvet cover and flat sheet. Pillowcases: standard or king, chosen per pair. */
    function variantFor(key, colour) {
      var entry = (piecesOf(fab())[SRC[key]] || {})[colour];
      if (!entry) return null;
      var v = entry.v, names = Object.keys(v);
      /* a set stands in for the single piece: its stock, the single price (null = unknown, so no "you save") */
      var setP = entry.set ? (SINGLE[fab().key.toLowerCase() + '|' + SRC[key]] || {}) : null;
      var mk = function (a, name) { return { id: a[0], price: setP ? (setP[name] != null ? setP[name] : null) : a[1], ok: a[2] === 1 }; };
      if (SRC[key] === 'pillow') { var want = state.ps[key]; return v[want] ? mk(v[want], want) : (names.length === 1 ? mk(v[names[0]], names[0]) : null); }
      var sz = state.size.toLowerCase(), tries = [sz];
      if (sz === 'king au') tries.push('king');
      for (var t = 0; t < tries.length; t++) {
        for (var i = 0; i < names.length; i++) {
          var parts = names[i].split(/\s*(?:&|\/|,)\s*/);
          if (names[i] === tries[t] || parts.indexOf(tries[t]) > -1) return mk(v[names[i]], names[i]);
        }
      }
      return null;
    }
    function canUse(key, colour) { if (soon(colour)) return false; var v = variantFor(key, colour); return !!(v && (v.ok || preorder(colour))); }
    function bundleVariant() { var a = CAT.bundle[state.fabric + '|' + sizeObj().b]; return a ? { id: a[0], price: a[1] } : null; }

    /* ---------- state ---------- */
    function pillowDefault(size) { return KINGP.indexOf(String(size).toLowerCase()) > -1 ? 'king' : 'standard'; }
    function fresh(fabricKey, size) {
      var f = FABS.filter(function (x) { return x.key === fabricKey; })[0] || FABS[0];
      var sz = size || (SIZES[1] || SIZES[0]).n;
      return { fabric: f.key, size: sz, ps: { pillow1: pillowDefault(sz), pillow2: pillowDefault(sz) }, c: {}, addons: {}, fo: true, so: true, open: 'duvet' };
    }
    function looksFor() {
      return (CAT.looks || []).filter(function (l) {
        if (String(l.fabric).toLowerCase() !== state.fabric.toLowerCase()) return false;
        return KEYS.every(function (k, i) { return !l.c[i] || canUse(k, l.c[i]); });
      });
    }
    function applyLook(look) { if (look) KEYS.forEach(function (k, i) { if (look.c[i] && canUse(k, look.c[i])) state.c[k] = look.c[i]; }); }
    /* every piece always has a usable colour: keep it, else the duvet colour, else the first on sale */
    function fill() {
      KEYS.forEach(function (k) {
        if (state.c[k] && canUse(k, state.c[k])) return;
        delete state.c[k];
        var d = state.c.duvet && canUse(k, state.c.duvet) ? state.c.duvet : coloursFor(k).filter(function (c) { return canUse(k, c); })[0];
        if (d) state.c[k] = d;
      });
    }
    function complete() { return KEYS.every(function (k) { return state.c[k] && canUse(k, state.c[k]); }); }

    /* ---------- link state (share) ---------- */
    function encode() {
      return '#bundle=' + encodeURIComponent([state.fabric, state.size, state.ps.pillow1, state.ps.pillow2].concat(KEYS.map(function (k) { return state.c[k] || ''; })).join('|'));
    }
    function decode() {
      var m = location.hash.match(/bundle=([^&]+)/); if (!m) return false;
      var p; try { p = decodeURIComponent(m[1]).split('|'); } catch (e) { return false; }
      if (p.length < 9 || !FABS.some(function (f) { return f.key === p[0]; })) return false;
      state = fresh(p[0], SIZES.some(function (x) { return x.n === p[1]; }) ? p[1] : null);
      if (pillowChoice(state.size)) {
        state.ps.pillow1 = p[2] === 'king' ? 'king' : 'standard';
        state.ps.pillow2 = p[3] === 'king' ? 'king' : 'standard';
      }
      KEYS.forEach(function (k, i) { if (p[4 + i] && canUse(k, p[4 + i])) state.c[k] = p[4 + i]; });
      state.fo = state.so = false;
      return true;
    }

    /* ---------- bed photo, or a 3D viewer pasted into the section ---------- */
    var photo = null, photoEl = $('[data-kbb-photo]');
    function srcFor(colour) {
      if (!colour) return null;
      var m = mo(colour); if (m && m.r) return { img: m.r };
      var r = (fab().renders || {})[colour];
      if (r) return { img: r };
      if (!CAT.base) return null;
      return { tint: tintOf(colour), base: CAT.base };
    }
    /* recolour photo (katha-bed-recolour.js): one real bed photo, every piece coloured, shams and bolster only when added */
    var RCFG = null; try { var rcEl = root.querySelector('[data-kbb-recolour]'); if (rcEl) RCFG = JSON.parse(rcEl.textContent); } catch (e) {}
    function lum(h) { var n = parseInt(h.slice(1), 16); return (n >> 16 & 255) * .3 + (n >> 8 & 255) * .59 + (n & 255) * .11; }
    function paintFor(name) {
      if (!name) return null;
      var hs = (paintOf(name).match(/#[0-9a-f]{6}/gi) || []);
      if (isStripe(name) && hs.length > 1) {
        /* stripe geometry from the swatch pattern "#base 0 Apx, #stripe Apx Bpx": the swatch draws 4.5 px per cm */
        var stops = [], re = /(#[0-9a-f]{6})\s+([\d.]+)(?:px)?\s+([\d.]+)px/gi, m;
        while ((m = re.exec(paintOf(name)))) stops.push({ c: m[1], a: +m[2], b: +m[3] });
        if (stops.length > 1) {
          var per = stops[1].b, base = stops[0], st = stops[1];
          return { name: name, hex: base.c, stripe: st.c, w: (st.b - st.a) / per, period: per / 4.5 };
        }
        var hx = hs.slice(0, 2).sort(function (x, y) { return lum(y) - lum(x); }); return { name: name, hex: hx[0], stripe: hx[1], w: .1 };
      }
      return { name: name, hex: tintOf(name) };
    }
    function addonPaint(re) {
      var a = activeAddons().filter(function (x) { return re.test(x.label || ''); })[0]; if (!a) return null;
      var o = pickAddonOpt(a, state.addons[a.id] || {}); return o ? paintFor(o[3] || state.c.duvet) : null;
    }
    /* 360°: 12 views round a 3D model of the bed, same colours; drag (or arrows) to turn. Add-ons show in the photo. */
    var spin = { on: false, i: 0, ui: null };
    function spinUI() {
      if (spin.ui || !RCFG || !RCFG.spin || !photoEl) return;
      var bar = document.createElement('div'); bar.className = 'kbb-spin';
      bar.innerHTML = '<button type="button" class="kbb-spin__go" aria-pressed="false">' + esc(TX.spinLabel || '360°') + '</button>' +
        '<span class="kbb-spin__turn" hidden><button type="button" data-turn="-1" aria-label="' + esc(TX.spinLeft || 'turn left') + '">‹</button>' +
        '<button type="button" data-turn="1" aria-label="' + esc(TX.spinRight || 'turn right') + '">›</button></span>';
      photoEl.appendChild(bar); spin.ui = bar;
      var go = bar.querySelector('.kbb-spin__go'), turn = bar.querySelector('.kbb-spin__turn');
      go.addEventListener('click', function () {
        spin.on = !spin.on; go.setAttribute('aria-pressed', spin.on); turn.hidden = !spin.on;
        photoEl.classList.toggle('is-spin', spin.on);
        var n = $('[data-kbb-note]'); if (n) n.textContent = spin.on ? (TX.spinNote || 'drag to turn the bed · add-ons show in the photo') : (TX.recolourNote || '');
        drawPhoto();
      });
      bar.addEventListener('click', function (e) { var b = e.target.closest('[data-turn]'); if (!b) return; spin.i += +b.getAttribute('data-turn'); drawPhoto(); });
      var x0 = null, i0 = 0;
      photoEl.addEventListener('pointerdown', function (e) { if (!spin.on || e.target.closest('button')) return; x0 = e.clientX; i0 = spin.i; photoEl.setPointerCapture(e.pointerId); });
      photoEl.addEventListener('pointermove', function (e) {
        if (x0 == null) return;
        var step = Math.round((x0 - e.clientX) / 40);   /* 12 views: about 40 px of drag per 30° */
        if (i0 + step !== spin.i) { spin.i = i0 + step; drawPhoto(); }
      });
      ['pointerup', 'pointercancel'].forEach(function (t) { photoEl.addEventListener(t, function () { x0 = null; }); });
    }
    function drawPhoto() {
      if (!photoEl) return;
      spinUI();
      if (!photo && RCFG && window.KathaBedRecolour) photo = window.KathaBedRecolour(photoEl, RCFG);
      if (!photo && window.KathaBedPhoto) photo = window.KathaBedPhoto(photoEl);
      if (!photo) return;
      var c = state.c;
      if (photo.recolour) {
        photo.set({ fabric: state.fabric, spin: spin.on ? spin.i : null, duvet: paintFor(c.duvet), fitted: paintFor(c.fitted), flat: paintFor(c.flat),
          back: paintFor(c.pillow1), front: paintFor(c.pillow2),
          bolster: spin.on ? null : addonPaint(/bolster/i), shams: spin.on ? null : addonPaint(/sham/i) });
        var rn = $('[data-kbb-note]'); if (rn && !spin.on) rn.textContent = TX.recolourNote || '';
        return;
      }
      photo.set({ duvet: srcFor(c.duvet), flat: srcFor(c.flat), back: srcFor(c.pillow1), front: srcFor(c.pillow2) });
      var tinted = ['duvet', 'flat', 'pillow1', 'pillow2'].some(function (k) { var m = mo(c[k]); return c[k] && !(m && m.r) && !(fab().renders || {})[c[k]]; });
      var note = $('[data-kbb-note]'); if (note) note.textContent = tinted ? TX.tintNote : TX.fittedNote;
    }
    function announce() {
      try {
        window.dispatchEvent(new CustomEvent('katha:bundle', { detail: {
          fabric: state.fabric, size: state.size,
          pillowSizes: { pair1: state.ps.pillow1, pair2: state.ps.pillow2 },
          colours: KEYS.reduce(function (o, k) { o[k] = state.c[k] || null; return o; }, {}),
          hex: KEYS.reduce(function (o, k) { o[k] = state.c[k] ? tintOf(state.c[k]) : null; return o; }, {})
        } }));
      } catch (e) {}
    }

    /* ---------- render ---------- */
    /* One shape for every colour: a square. Fabric and size fold to one line once chosen; one piece open at a time. */
    var GIFT = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="12"></rect><path d="M2.5 8.5h19M12 8.5v12M12 8.5c-1.5-3-5-4-5-1.5S12 8.5 12 8.5zM12 8.5c1.5-3 5-4 5-1.5S12 8.5 12 8.5z"></path></svg>';
    function dot(name) { return '<i style="background:' + (name ? esc(paintOf(name)) : 'transparent') + '"></i>'; }
    function isStripe(name) { return /stripe/i.test(name); }
    function fabColours(f) { return orderOf(f).filter(function (c) { return !hidden(c, f.key); }); }
    function fromPrice(f) {
      var p = Object.keys(CAT.bundle).filter(function (k) { return k.indexOf(f.key + '|') === 0; }).map(function (k) { return CAT.bundle[k][1]; });
      return p.length ? Math.min.apply(null, p) : 0;
    }
    function cm(z) { var m = String(z.cm).match(/(\d+)\D+(\d+)/); return m ? { w: +m[1], l: +m[2] } : { w: 160, l: 200 }; }
    function mattress(z, scale) { var d = cm(z); return '<i class="kbb-mat" style="width:' + (d.w / 200 * scale).toFixed(1) + 'px;height:' + (d.l / 220 * scale * 1.15).toFixed(1) + 'px"></i>'; }
    /* each piece's own measurement for the chosen bed size (size guide columns: mattress & fitted, flat, duvet) */
    function pieceDim(k) {
      var row = (CAT.sizeRows || '').split('\n').map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); }).filter(function (r) { return r[0] === state.size; })[0];
      var col = { fitted: 1, flat: 2, duvet: 3 }[k];
      if (!row || !col || !row[col]) return '';
      return row[col] + (k === 'fitted' ? ' × 40' : '') + ' cm';
    }
    function looksShown() { return looksFor().slice(0, 8); }
    function diag(l) { var c = l.c, b = [c[4], c[3], c[1], c[2]].filter(function (x) { return x && x !== c[0]; })[0]; return [c[0], b || c[0]]; }
    function lookLine(l) {
      if (!l) return '';
      var c = l.c, two = function (a, b) { return a === b || !b ? a : a + ' ' + TX.and + ' ' + b; };
      return '<b>' + esc(l.name) + '</b> <span>' + esc(TX.lookLine.replace('[duvet]', c[0]).replace('[sheets]', two(c[1], c[2])).replace('[pillows]', two(c[3], c[4]))) + '</span>';
    }
    function lookOn(l) { return KEYS.every(function (k, j) { return !l.c[j] || state.c[k] === l.c[j]; }); }
    function lookHref(l) {
      return '#bundle=' + encodeURIComponent([state.fabric, state.size, state.ps.pillow1, state.ps.pillow2].concat(l.c).join('|'));
    }

    function render() {
      fill();
      var f = fab();
      var fk = String(state.fabric || '').toLowerCase();   /* swatch texture follows the fabric (CSS [data-tex]) */
      root.setAttribute('data-tex', /eucalyptus/.test(fk) ? 'eucalyptus' : /cotton/.test(fk) ? 'cotton' : 'linen');
      // 1 fabric
      var dots = function (x) { return '<span class="kbb-dots" aria-hidden="true">' + fabColours(x).map(dot).join('') + '</span>'; };
      var thumb = function (x) { return '<span class="kbb-fab__img">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</span>'; };
      $('[data-kbb-fabrics]').innerHTML = state.fo ? ALL.map(function (x) {
        var ok = FABS.indexOf(x) > -1, lo = fromPrice(x), n = fabColours(x).length;
        return '<button type="button" role="radio" aria-checked="' + (x.key === state.fabric) + '" class="kbb-fab" data-fab="' + esc(x.key) + '"' + (ok ? '' : ' disabled') + '>' + thumb(x) +
          '<span class="kbb-fab__txt"><span class="kbb-fab__name">' + esc(x.label) + '</span>' + (x.feel ? '<span class="kbb-fab__feel">' + esc(x.feel) + '</span>' : '') + '</span>' +
          '<span class="kbb-fab__from">' + (ok ? (lo ? esc(TX.from) + ' ' + money(lo) : '') : esc(TX.fabricSoon)) + '</span>' +
          '<span class="kbb-fab__cols">' + dots(x) + '<small>' + n + ' ' + esc(TX.colours) + '</small></span></button>';
      }).join('') : '<div class="kbb-fold">' + thumb(f) +
          '<span class="kbb-fab__txt"><span class="kbb-fab__name">' + esc(f.label) + '</span><span class="kbb-fab__feel">' + fabColours(f).length + ' ' + esc(TX.colours) + ', ' + esc(TX.from) + ' ' + money(fromPrice(f)) + '</span></span>' +
          '<button type="button" class="kbb-link" data-kbb-fabopen>' + esc(TX.edit) + '</button>' +
          '<span class="kbb-fab__cols">' + dots(f) + '</span></div>';
      // 2 size: mattresses drawn to scale
      var z = sizeObj();
      $('[data-kbb-sizes]').classList.toggle('is-folded', !state.so);
      $('[data-kbb-sizes]').innerHTML = state.so ? SIZES.map(function (s) {
        return '<button type="button" role="radio" aria-checked="' + (s.n === state.size) + '" class="kbb-size" data-size="' + esc(s.n) + '"><span class="kbb-size__mat" aria-hidden="true">' + mattress(s, 48) + '</span><span>' + esc(s.n) + '</span>' + (s.cm ? '<small>' + esc(s.cm) + '</small>' : '') + '</button>';
      }).join('') : '<div class="kbb-fold"><span class="kbb-size__mini" aria-hidden="true">' + mattress(z, 22) + '</span>' +
          '<span class="kbb-fab__txt"><span class="kbb-fab__name">' + esc(z.n) + '</span><span class="kbb-fab__feel">' + esc(TX.sizeLine.replace('[cm]', z.cm)) + '</span></span>' +
          '<button type="button" class="kbb-link" data-kbb-sizeopen>' + esc(TX.edit) + '</button></div>';
      // 3 combos: up to 8 squares, two colours on the diagonal or the combo's photo
      var looks = looksShown();
      $('[data-kbb-looks-wrap]').hidden = !looks.length;
      $('[data-kbb-looks]').innerHTML = looks.map(function (l, i) {
        var d = diag(l), bg = l.img ? 'background-image:url(\'' + esc(l.img) + '\')' : 'background:' + esc(paintOf(d[1]));
        return '<a class="kbb-look" href="' + esc(lookHref(l)) + '" data-look="' + i + '" aria-current="' + lookOn(l) + '" aria-label="' + esc(l.name) + '" title="' + esc(l.name) + '" style="' + bg + '">' +
          (l.img ? '' : '<i style="background:' + esc(paintOf(d[0])) + '"></i>') + '</a>';
      }).join('');
      $('[data-kbb-look-name]').innerHTML = lookLine(looks.filter(lookOn)[0]);
      // reference photos of the chosen combo (up to 3, added in Atelier Sync > Website colours)
      var cur = looks.filter(lookOn)[0], refs = $('[data-kbb-refs]');
      if (refs) {
        var im = (cur && cur.imgs) || [];
        refs.hidden = !im.length;
        refs.innerHTML = im.length ? '<div class="kbb-refs__row">' + im.map(function (u) {
          return '<a href="' + esc(u) + '" target="_blank" rel="noopener"><img src="' + esc(u) + '" alt="' + esc(cur.name) + '" loading="lazy" width="300" height="300"></a>';
        }).join('') + '</div>' : '';
      }
      // pieces: one open at a time
      $('[data-kbb-pieces]').innerHTML = KEYS.map(function (k, i) {
        var c = state.c[k], open = state.open === k, names = coloursFor(k);
        var row = function (list) {
          return '<div class="kbb-sws" role="radiogroup" aria-label="' + esc(TX.pieces[i]) + '">' + list.map(function (name) {
            var ok = canUse(k, name), pre = ok && preorder(name), why = soon(name) || (ok ? (pre ? TX.preLabel + ', ' + pre : '') : TX.soldOut);
            return '<button type="button" role="radio" class="kbb-sw' + (ok ? '' : ' is-off') + (pre ? ' is-pre' : '') + '" data-piece="' + k + '" data-colour="' + esc(name) + '" aria-checked="' + (name === c) + '"' + (ok ? '' : ' disabled') +
              ' title="' + esc(name + (why ? ', ' + why : '')) + '" aria-label="' + esc(name + (why ? ', ' + why : '')) + '">' + dot(name) + '</button>';
          }).join('') + '</div>';
        };
        var solid = names.filter(function (n) { return !isStripe(n); }), stripe = names.filter(isStripe);
        var size = PILLOWS.indexOf(k) > -1 && pillowChoice(state.size) ? '<div class="kbb-seg" role="radiogroup" aria-label="' + esc(TX.pieces[i] + ', ' + TX.pillowLabel) + '">' +
          ['standard', 'king'].map(function (ps) { return '<button type="button" role="radio" data-ps="' + ps + '" data-pk="' + k + '" aria-checked="' + (state.ps[k] === ps) + '">' + esc(ps === 'king' ? TX.pillowKing : TX.pillowStd) + '</button>'; }).join('') + '</div>' : '';
        var dim = PILLOWS.indexOf(k) > -1 ? (state.ps[k] === 'king' ? TX.pillowKing : TX.pillowStd) : (pieceDim(k) || state.size);
        var meta = esc(f.label) + ', ' + esc(c || TX.pick) + ', ' + esc(dim);
        return '<li class="kbb-piece' + (open ? ' is-open' : '') + '">' +
          '<button type="button" class="kbb-piece__head" data-open="' + k + '" aria-expanded="' + open + '">' + dot(c) +
            '<span class="kbb-piece__txt"><span class="kbb-piece__name">' + esc(TX.pieces[i] || k) + '</span><span class="kbb-piece__c">' + meta + '</span></span>' +
            '<span class="kbb-piece__act">' + esc(open ? TX.done : TX.edit) + '</span></button>' +
          (open ? '<div class="kbb-piece__body">' +
            (stripe.length ? '<p class="kbb-grp">' + esc(TX.solids) + '</p>' + row(solid) + '<p class="kbb-grp">' + esc(TX.stripes) + '</p>' + row(stripe) : row(solid)) +
            '<p class="kbb-piece__note"><b>' + esc(c || TX.pick) + '</b>' + (c && preorder(c) ? ', <span class="kbb-pre">' + esc(TX.preLabel + ', ' + preorder(c)) + '</span>' : '') + (TX.pieceNotes[i] ? ', ' + esc(TX.pieceNotes[i]) : '') + '</p>' + size + '</div>' : '') + '</li>';
      }).join('');
      // 4 add-ons: ticking one opens its colours, sizes or card message
      var ads = (CAT.addons || []).filter(function (a) { return !a.fabric || a.fabric.toLowerCase() === state.fabric.toLowerCase(); });
      $('[data-kbb-addons-wrap]').hidden = !ads.length;
      $('[data-kbb-addons]').innerHTML = ads.map(function (a) {
        var st = state.addons[a.id] || {}, on = !!st.on, opt = pickAddonOpt(a, st);
        var now = opt ? Math.round(opt[1] * (100 - a.off) / 100) : 0;
        var colours = uniq(a.opts.map(function (o) { return o[3]; }).filter(Boolean));
        var sizes = uniq(a.opts.map(function (o) { return o[4]; }).filter(Boolean));
        var off = colours.filter(function (cc) { return !a.opts.some(function (o) { return o[3] === cc && o[2] === 1; }); });
        /* photo of the chosen colour (variant image, or that colour's product photo); then the add-on photo; swatch only when no photo exists */
        var pic = opt && opt[3] ? opt[5] : a.img;
        var chip = pic ? '<img src="' + esc(pic) + '" alt="" loading="lazy" width="80" height="80">' : (opt && opt[3] ? dot(opt[3]) : GIFT);
        var meta = on ? [opt && opt[3], opt && opt[4]].filter(Boolean).join(', ') || (st.m ? '“' + st.m.slice(0, 40) + (st.m.length > 40 ? '…' : '') + '”' : a.note) : a.note;
        var body = '';
        if (on && (colours.length > 1 || sizes.length > 1 || a.msg)) {
          body = '<div class="kbb-addon__opts">' +
            (sizes.length > 1 ? '<p class="kbb-grp">' + esc(TX.sizeLabel) + '</p><div class="kbb-seg" role="radiogroup">' + sizes.map(function (s) {
              var o = a.opts.filter(function (x) { return x[4] === s && (!opt || !opt[3] || x[3] === opt[3]); })[0];
              return '<button type="button" role="radio" data-addon-s="' + esc(a.id) + '" data-v="' + esc(s) + '" aria-checked="' + (opt && opt[4] === s) + '">' + esc(s) + (o ? ' <small>' + money(Math.round(o[1] * (100 - a.off) / 100)) + '</small>' : '') + '</button>';
            }).join('') + '</div>' : '') +
            (colours.length > 1 ? '<p class="kbb-grp">' + esc(TX.colourLabel) + '</p><div class="kbb-sws" role="radiogroup">' + colours.map(function (cc) {
              var no = off.indexOf(cc) > -1;
              return '<button type="button" role="radio" class="kbb-sw' + (no ? ' is-off' : '') + '" data-addon-c="' + esc(a.id) + '" data-v="' + esc(cc) + '" aria-checked="' + (opt && opt[3] === cc) + '"' + (no ? ' disabled' : '') + ' title="' + esc(cc + (no ? ', ' + TX.soldOutShort : '')) + '" aria-label="' + esc(cc + (no ? ', ' + TX.soldOutShort : '')) + '">' + dot(cc) + '</button>';
            }).join('') + '</div>' + (off.length ? '<p class="kbb-piece__note">' + esc(TX.crossed) + '</p>' : '') : '') +
            (a.msg ? '<label class="kbb-field"><span class="kbb-grp">' + esc(TX.msgLabel) + '</span><textarea rows="3" maxlength="200" data-addon-msg="' + esc(a.id) + '">' + esc(st.m || '') + '</textarea><span class="kbb-piece__note" data-msg-count="' + esc(a.id) + '">' + (st.m || '').length + ' / 200. ' + esc(TX.msgBlank) + '</span></label>' : '') +
            '</div>';
        }
        return '<li class="kbb-addon' + (on ? ' is-on' : '') + '">' +
          '<label class="kbb-addon__row"><input type="checkbox" data-addon="' + esc(a.id) + '"' + (on ? ' checked' : '') + '><span class="kbb-addon__ph">' + chip + '</span>' +
            '<span class="kbb-addon__txt"><span>' + esc(a.label) + '</span><small>' + esc(meta || '') + '</small></span>' +
            '<span class="kbb-addon__p">' + (opt ? (a.off ? '<span>' + money(now) + '</span><s><span>' + esc(TX.usually) + ' </span>' + money(opt[1]) + '</s>' : '<span>' + money(opt[1]) + '</span>') : '') + '</span></label>' +
          body + '</li>';
      }).join('');
      // legend + bar
      $('[data-kbb-legend]').innerHTML = KEYS.map(function (k, i) {
        var c = state.c[k];
        return '<li title="' + esc(TX.pieces[i] + ': ' + (c || '–')) + '">' + dot(c) + '<span class="kbb-legend__c">' + esc(TX.pieces[i] + ': ' + (c || '–')) + '</span></li>';
      }).join('');
      $('[data-kbb-bar-dots]').innerHTML = KEYS.map(function (k) { return dot(state.c[k]); }).join('');
      prices();
      drawPhoto();
      announce();
      if (history.replaceState) history.replaceState(history.state, '', location.pathname + location.search + encode());
      var wa = $('[data-kbb-wa]');
      if (wa) { try { var u = new URL(wa.href); var t = (u.searchParams.get('text') || '').split(' ' + location.origin)[0]; u.searchParams.set('text', t + ' ' + location.href); wa.href = u.toString(); } catch (e) {} }
    }
    function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
    /* add-on option: the chosen colour/size, else a colour already in the bed, else the first on sale */
    function pickAddonOpt(a, st) {
      var ok = a.opts.filter(function (o) { return o[2] === 1; }); if (!ok.length) ok = a.opts;
      var sizeOk = function (o) { return !st.s || !o[4] || o[4] === st.s; };
      var wants = [st.c, state.c.duvet, state.c.pillow2, state.c.pillow1, state.c.fitted, state.c.flat].filter(Boolean);
      for (var i = 0; i < wants.length; i++) {
        var m = ok.filter(function (o) { return o[3] === wants[i] && sizeOk(o); });
        if (m.length) return m[0];
      }
      return ok.filter(function (o) { return !o[3] && sizeOk(o); })[0] || ok.filter(sizeOk)[0] || ok[0] || null;
    }
    function activeAddons() {
      return (CAT.addons || []).filter(function (a) {
        var st = state.addons[a.id];
        return st && st.on && (!a.fabric || a.fabric.toLowerCase() === state.fabric.toLowerCase());
      });
    }
    function totals() {
      var bv = bundleVariant(), sep = 0, all = true;
      KEYS.forEach(function (k) { var c = state.c[k], v = c && variantFor(k, c); if (v && v.price != null) sep += v.price; else all = false; });
      var add = 0, addWas = 0;
      activeAddons().forEach(function (a) { var o = pickAddonOpt(a, state.addons[a.id]); if (o) { add += Math.round(o[1] * (100 - a.off) / 100); addWas += o[1]; } });
      var bundle = bv ? bv.price : 0;
      var save = all && bv && sep > bundle ? sep - bundle : 0;
      return { bundle: bundle, sep: sep, save: save, total: bundle + add, addSave: addWas - add, was: (save ? sep : bundle) + addWas };
    }
    function prices() {
      var t = totals();
      var bs = $('[data-kbb-bar-save]'), bw = $('[data-kbb-bar-was]');
      var all = t.save + t.addSave, pctAll = t.was ? Math.floor(all / t.was * 100) : 0;
      // the saving is the loudest line by the button
      var band = $('[data-kbb-band]');
      band.hidden = !(all > 0);
      if (all > 0) {
        $('[data-kbb-band-save]').textContent = TX.bandSave.replace('[amount]', money(all)).replace('[percent]', pctAll);
        var preNotes = uniq(KEYS.map(function (k) { return state.c[k] ? preorder(state.c[k]) : ''; }).filter(Boolean));
        var sl = $('[data-kbb-shipline] span[data-base]');
        if (sl) sl.textContent = preNotes.length ? TX.preShip.replace('[note]', preNotes.join(', ')) : sl.getAttribute('data-base');
        var pl = $('[data-kbb-preline]'); if (pl) { pl.hidden = !preNotes.length; pl.textContent = preNotes.length ? TX.preLine.replace('[note]', preNotes.join(', ')) : ''; }
        $('[data-kbb-band-split]').textContent = t.addSave > 0 && t.save > 0 ? TX.bandSplit.replace('[bundle]', money(t.save)).replace('[addons]', money(t.addSave)) : TX.bandBundle;
      }
      bs.textContent = all > 0 ? TX.barSave.replace('[amount]', money(all)).replace('[percent]', pctAll) : '';
      $('[data-kbb-total]').textContent = money(t.total);
      $('[data-kbb-total-was]').textContent = all > 0 ? money(t.was) : '';
      $('[data-kbb-bar-total]').textContent = money(t.total);
      bw.textContent = all > 0 ? money(t.was) : '';
      var ship = $('[data-kbb-ship]');
      if (CAT.freeShip > 0) {
        ship.hidden = false;
        var left = CAT.freeShip - t.total;
        ship.classList.toggle('is-done', left <= 0);
        $('[data-kbb-ship-txt]').textContent = left > 0 ? TX.shipLeft.replace('[amount]', money(left)) : TX.shipDone;
        $('[data-kbb-ship-fill]').style.width = Math.min(100, t.total / CAT.freeShip * 100) + '%';
      }
      var ready = complete() && !!bundleVariant();
      $('[data-kbb-add]').disabled = !ready; $('[data-kbb-bar-add]').disabled = !ready;
    }

    /* ---------- events ---------- */
    function refocus(sel) { try { var f = root.querySelector(sel); if (f) f.focus({ preventScroll: true }); } catch (e) {} }
    function setAddon(id, key, val) { var st = state.addons[id] = state.addons[id] || {}; st[key] = val; }
    root.addEventListener('click', function (e) {
      var lk = e.target.closest('a[data-look]');
      if (lk && root.contains(lk)) { e.preventDefault(); applyLook(looksShown()[+lk.dataset.look]); render(); refocus('[data-look="' + lk.dataset.look + '"]'); return; }
      var b = e.target.closest('button'); if (!b || !root.contains(b) || b.disabled) return;
      var d = b.dataset;
      if (d.fab) {
        state.fo = false;
        if (d.fab !== state.fabric) {
          var keep = state.c, addons = state.addons, ps = state.ps, so = state.so;
          state = fresh(d.fab, state.size); state.ps = ps; state.addons = addons; state.so = so; state.fo = false;
          applyLook(looksFor()[0]);
          KEYS.forEach(function (k) { if (!state.c[k] && keep[k] && canUse(k, keep[k])) state.c[k] = keep[k]; });
        }
        render(); refocus('[data-kbb-fabopen]'); return;
      }
      if (b.hasAttribute('data-kbb-fabopen')) { state.fo = true; render(); refocus('[data-fab="' + state.fabric + '"]'); return; }
      if (b.hasAttribute('data-kbb-sizeopen')) { state.so = true; render(); refocus('[data-size="' + state.size + '"]'); return; }
      if (d.size) { state.size = d.size; state.so = false; state.ps = { pillow1: pillowDefault(d.size), pillow2: pillowDefault(d.size) }; render(); refocus('[data-kbb-sizeopen]'); return; }
      if (d.open) {
        if (state.open === d.open) { var nx = KEYS[KEYS.indexOf(d.open) + 1]; state.open = nx || null; }   // "done" closes and opens the next piece
        else state.open = d.open;
        render(); refocus('[data-open="' + (state.open || d.open) + '"]'); return;
      }
      if (d.colour) { state.c[d.piece] = d.colour; render(); refocus('[data-piece="' + d.piece + '"][data-colour="' + d.colour.replace(/"/g, '\\"') + '"]'); return; }
      if (d.ps && pillowChoice(state.size)) { state.ps[d.pk] = d.ps; render(); refocus('[data-pk="' + d.pk + '"][data-ps="' + d.ps + '"]'); return; }
      if (d.addonC) { setAddon(d.addonC, 'c', d.v); render(); refocus('[data-addon-c="' + d.addonC + '"][data-v="' + d.v.replace(/"/g, '\\"') + '"]'); return; }
      if (d.addonS) { setAddon(d.addonS, 's', d.v); render(); refocus('[data-addon-s="' + d.addonS + '"][data-v="' + d.v.replace(/"/g, '\\"') + '"]'); return; }
      if (b.hasAttribute('data-kbb-reset')) { state = fresh(state.fabric); state.fo = state.so = true; applyLook(looksFor()[0]); render(); return; }
      if (b.hasAttribute('data-kbb-copy')) {
        var u = location.href, o = b.textContent;
        var done = function () { b.textContent = TX.copied; setTimeout(function () { b.textContent = o; }, 2000); };
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) { navigator.share({ title: document.title, url: u }).catch(function () {}); return; }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(u).then(done, function () { window.prompt('', u); });
        else window.prompt('', u);
        return;
      }
      if (b.hasAttribute('data-kbb-sizeguide')) {
        var dlg = $('[data-kbb-sg]');
        if (dlg) dlg.querySelectorAll('[data-sg-row]').forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-sg-row') === state.size); });
        if (dlg && dlg.showModal) dlg.showModal(); return;
      }
      if (b.hasAttribute('data-kbb-sg-close')) { $('[data-kbb-sg]').close(); return; }
      if (b.hasAttribute('data-kbb-add') || b.hasAttribute('data-kbb-bar-add')) add(b);
    });
    root.addEventListener('change', function (e) {
      var t = e.target, d = t.dataset;
      if (d.addon) { setAddon(d.addon, 'on', t.checked); render(); refocus('[data-addon="' + d.addon + '"]'); }
    });
    /* hover or focus a combo: show its name and colours */
    function lookHint(e) { var a = e.target.closest && e.target.closest('a[data-look]'); var l = a ? looksShown()[+a.dataset.look] : looksShown().filter(lookOn)[0]; $('[data-kbb-look-name]').innerHTML = lookLine(l); }
    root.addEventListener('mouseover', lookHint); root.addEventListener('focusin', lookHint);
    root.addEventListener('mouseout', function (e) { if (e.target.closest && e.target.closest('a[data-look]')) $('[data-kbb-look-name]').innerHTML = lookLine(looksShown().filter(lookOn)[0]); });
    root.addEventListener('input', function (e) {
      var d = e.target.dataset; if (!d.addonMsg) return;
      setAddon(d.addonMsg, 'm', e.target.value);
      var n = root.querySelector('[data-msg-count="' + d.addonMsg + '"]'); if (n) n.textContent = e.target.value.length + ' / 200. ' + TX.msgBlank;
    });
    var sg = $('[data-kbb-sg]'); if (sg) sg.addEventListener('click', function (e) { if (e.target === sg) sg.close(); });

    var busy = false;
    function add(btn) {
      var bv = bundleVariant(); if (busy || !bv || !complete()) return;
      busy = true;
      var P = TX.props, props = {};
      props[P[0]] = fab().label; props[P[1]] = state.size;
      KEYS.forEach(function (k, i) { var pre = preorder(state.c[k]); props[P[2 + i]] = state.c[k] + (PILLOWS.indexOf(k) > -1 ? ' · ' + (state.ps[k] === 'king' ? 'King' : 'Standard') : '') + (pre ? ' · ' + TX.preLabel + ' (' + pre + ')' : ''); });
      var items = [{ id: bv.id, quantity: 1, properties: props }];
      activeAddons().forEach(function (a) {
        var st = state.addons[a.id], o = pickAddonOpt(a, st); if (!o) return;
        var line = { id: o[0], quantity: 1 };
        if (a.msg && st.m) line.properties = { 'Card message': st.m };
        items.push(line);
      });
      var buttons = [$('[data-kbb-add]'), $('[data-kbb-bar-add]')], label = buttons.map(function (x) { return x.textContent; });
      buttons.forEach(function (x) { x.disabled = true; x.setAttribute('aria-busy', 'true'); });
      btn.textContent = TX.adding; $('[data-kbb-err]').hidden = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          btn.textContent = TX.added;
          var preview = new URLSearchParams(location.search).get('view') ? '?view=redesign' : '';
          location.href = TX.cartUrl + preview;
        })
        .catch(function () {
          busy = false;
          buttons.forEach(function (x, i) { x.disabled = false; x.removeAttribute('aria-busy'); x.textContent = label[i]; });
          $('[data-kbb-err]').hidden = false;
        });
    }

    /* sticky bar: price follows the scroll on every screen, until the main button is in view */
    var bar = $('[data-kbb-bar]'), cta = $('[data-kbb-add]'), ctaSeen = false;
    function setBar() {
      var show = !ctaSeen;
      bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show));
      $('[data-kbb-bar-add]').tabIndex = show ? 0 : -1;
      document.body.classList.toggle('kbb-has-bar', show);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { ctaSeen = en[0].isIntersecting || en[0].boundingClientRect.top < 0; setBar(); }, { threshold: 0 }).observe(cta);
    }

    /* start: a shared link, else the first look so the bed is never empty */
    if (!decode()) { state = fresh(FABS[0].key); applyLook(looksFor()[0]); }
    render();
    setBar();
    if (!photo && photoEl) window.addEventListener('load', drawPhoto);
  }
})();
